<template>
  <div class="content-wrapper">
    <vx-card>
		<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner ">
			<vs-tab label="Seller Info">
				<InfoForm
					:form="form"
					:e="e"
				></InfoForm>
			</vs-tab>
			<vs-tab label="Theme">
				<ThemeForm
					:form="form"
					:e="e"
				></ThemeForm>
			</vs-tab>
			<vs-tab label="Payments">
				<PaymentForm
					:form="form"
					:e="e"
				></PaymentForm>
			</vs-tab>
			<vs-tab label="Tracking">
				<TrackingForm
					:form="form"
					:e="e"
				></TrackingForm>
			</vs-tab>
			<vs-tab label="Documents">
				<DocumentForm
					:form="form"
					:e="e"
				></DocumentForm>
			</vs-tab>
			<vs-tab label="Defaults">
				<DefaultForm
					:form="form"
					:e="e"
				></DefaultForm>
			</vs-tab>
			<vs-tab label="Contact">
				<ContactForm
					:form="form"
					:e="e"
				></ContactForm>
			</vs-tab>
			<vs-tab label="Fee">
				<div class="vx-row mb-6">
					<div class="vx-col sm:w-1/3 w-full">
						<span>Fee</span>
						<div style="font-size:0.75rem; color:#aaa;"></div>
					</div>
					<div class="vx-col sm:w-2/3 w-full">
						<vs-input
							class="w-full"
							v-model="form.fee"
							type="number"
						/>
					</div>
				</div>
				<div style="height:10px;"></div>
				<div class="vx-row pt-5 mt-5">
					<div class="vx-col w-full ml-auto">
						<vs-button class="mr-3 mb-2" @click="submitBasic">Submit</vs-button>
					</div>
				</div>
			</vs-tab>
			<vs-tab label="Advanced">
				<AdvancedForm
					:form="form"
					:e="e"
				></AdvancedForm>
			</vs-tab>
		</vs-tabs>
    </vx-card>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import InfoForm from "@/components/soldoutt/merchant/InfoForm";
import ContactForm from "@/components/soldoutt/merchant/ContactForm";
import ThemeForm from "@/components/soldoutt/merchant/ThemeForm";
import PaymentForm from "@/components/soldoutt/merchant/PaymentForm";
import TrackingForm from "@/components/soldoutt/merchant/TrackingForm";
import DocumentForm from "@/components/soldoutt/merchant/DocumentForm";
import DefaultForm from "@/components/soldoutt/merchant/DefaultForm";
import AdvancedForm from "@/components/soldoutt/merchant/AdvancedForm";

export default {
  components: {
	InfoForm,
	ContactForm,
	ThemeForm,
	PaymentForm,
	TrackingForm,
	DocumentForm,
	DefaultForm,
	AdvancedForm
  },
  data: () => ({
    activeTab: 0,
    form: {
		pay_creditcard: 1,
		pay_transfer: 1,
		disinttrack: 0

	},
    e: null,
	bankList: [
		{
			name: 'Kasikorn Bank',
			code: 'kbank'
		},
		{
			name: 'Siam Commercial Bank',
			code: 'scb'
		},
		{
			name: 'Krungthai Bank',
			code: 'ktb'
		},
		{
			name: 'Bank of Ayudhya',
			code: 'bay'
		},
		{
			name: 'Bangkok Bank',
			code: 'bbl'
		}
	],
  }),
  created() {
    setTimeout(() => {
      this.fethData();
    }, 1000);
  },
  methods: {
    fethData() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      Service.Event.get(data.e)
        .then(res => {
			this.form = res.data.event.merchant;
			this.form.wht_status = res.data.event.merchant.wht_status ? res.data.event.merchant.wht_status: '1'
			this.form.pay_creditcard = res.data.event.merchant.pay_creditcard === null ? '0': res.data.event.merchant.pay_creditcard
			this.form.pay_transfer = res.data.event.merchant.pay_transfer === null ? '0' : res.data.event.merchant.pay_transfer
			this.form.disinttrack = res.data.event.merchant.disinttrack ? res.data.event.merchant.disinttrack: 'NULL'
			this.e = res.data.event.slug;
        })
        .catch(e => {
          /* this.$router.push("/pages/error-404").catch(() => {}); */
        });
    },
    submitBasic() {
		this.$vs.loading();
		const formData = new FormData();
                const dataKeyForms = Object.keys(this.form);
                for (let index = 0; index < dataKeyForms.length; index++) {
                    const key = dataKeyForms[index];
                    const value = this.form[key];
                    formData.append(key, value);
                }
		Service.Event.saveMerchant(formData, this.e)
		.then(res => {
			this.$vs.loading.close();
			this.$vs.notify({
				title: "Success",
				text: "Update complete.",
				color: "success"
			});
		})
		.catch(e => {
			this.$vs.loading.close();
		});
	}
  }
};
</script>
